import styled from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';

import {
  gemAnimation,
  reversedGemAnimation,
} from '@/modules/jackpot/components/JackpotGemsPack/styled';
import { device, hexToRGB } from '@/styles/helpers';

const winnerBg = getCDNImageUrl('/jackpot/winnerModal/winnerBg.webp');

export const ScJackpotWinnerModal = styled.div`
  max-width: 640px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  gap: 24px;
  background-image: url(${winnerBg});
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 64px auto;
  position: relative;
  overflow: hidden;
  z-index: 1;

  & > .logo {
    max-width: 364px;
    width: 100%;
  }

  & > .congrats {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.27;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  & > .prize {
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .sum {
      font-size: 56px;
      line-height: 1;
      letter-spacing: 0.03em;
    }

    .win-text {
      font-size: 22px;
      line-height: 1.27;
      letter-spacing: 0.02em;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }
  }

  .blueWithConfetti,
  .pinkWithConfetti,
  .greenWithConfetti,
  .multipleConfetti,
  .singleConfetti,
  .bluredPink,
  .bluredBlue,
  .bluredGreen {
    position: absolute;
    aspect-ratio: 1/1;
    z-index: -1;
  }

  .greenWithConfetti,
  .multipleConfetti,
  .singleConfetti,
  .bluredPink {
    display: none;
  }

  .bluredBlue {
    width: 380px;
    top: 175px;
    left: -120px;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .bluredGreen {
    width: 286px;
    top: -140px;
    right: 50px;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  .bluredPink {
    width: 340px;
    top: 600px;
    right: -130px;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  .pinkWithConfetti {
    width: 280px;
    top: 117px;
    right: -70px;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .blueWithConfetti {
    width: 154px;
    top: 90px;
    left: 50px;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .greenWithConfetti {
    width: 154px;
    top: 640px;
    left: 20px;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  .multipleConfetti {
    width: 154px;
    top: 550px;
    right: calc(10vw - (154px / 2));
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .singleConfetti {
    width: 154px;
    top: 50px;
    right: calc(40vw - (154px / 2));
    animation: ${reversedGemAnimation} infinite 7s ease-out;
    z-index: 2;
  }

  @media (${device.mobileS}) {
    border-radius: 0;
    min-height: 100vh;
    max-width: 100vw;
    justify-content: center;
    padding: 32px 16px;
    margin: 0;
    & > .logo {
      max-width: 292px;
    }

    .greenWithConfetti,
    .multipleConfetti,
    .singleConfetti,
    .bluredPink {
      display: block;
    }

    .bluredGreen {
      top: -140px;
      right: -110px;
    }

    .bluredBlue {
      top: 225px;
      left: -220px;
    }

    .pinkWithConfetti {
      top: 117px;
      right: -190px;
    }

    .blueWithConfetti {
      top: 120px;
      left: -75px;
    }
  }
`;
